import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getUser } from './getUser';

// If the `login-verify` call fails to fetch teamsInfo, `teams` can get set to null.
export const getUserTeams = createSelector(getUser, user => get('teams', user) || []);